import { PenLine } from "lucide-react";
import { ManualeLayout, Scheda, P, Steps, Bullets, Callout, FAQ } from "@/pages/manuali/ManualeLayout";

const A = "#0EA5E9";
const SEZIONI = [
  { id: "intro", titolo: "Cos'è Assietica Sign" },
  { id: "clienti", titolo: "Clienti (anagrafiche firmatari)" },
  { id: "documenti", titolo: "Documenti da firmare" },
  { id: "pratiche", titolo: "Pratiche di firma" },
  { id: "livelli", titolo: "Livelli: OTP e OTP + documento" },
  { id: "invio", titolo: "Invio link e promemoria" },
  { id: "cliente", titolo: "Come firma il cliente" },
  { id: "certificato", titolo: "Certificato e documento firmato" },
  { id: "legale", titolo: "Valore e note legali" },
  { id: "faq", titolo: "Domande frequenti" },
];

export default function ManualeSign() {
  return (
    <ManualeLayout titolo="Assietica Sign" sottotitolo="Firma e accettazione digitale dei documenti" icona={PenLine} accent={A} sezioni={SEZIONI}>
      <Scheda id="intro" n={1} titolo="Cos'è Assietica Sign" accent={A}>
        <P>Assietica Sign consente di far firmare digitalmente un documento (PDF) da un cliente, tramite un link, con verifica OTP e raccolta delle evidenze tecniche. Il flusso è: creo il cliente, carico il documento, creo la pratica di firma, invio il link, il cliente firma e riceve il documento firmato con il certificato.</P>
      </Scheda>

      <Scheda id="clienti" n={2} titolo="Clienti (anagrafiche firmatari)" accent={A}>
        <Steps items={[
          "Apri 'Clienti' e crea/cerca il firmatario (puoi attingere all'anagrafica condivisa dell'agenzia).",
          "Verifica nome, codice fiscale, email e cellulare: servono per l'invio del link e per l'OTP.",
        ]} />
      </Scheda>

      <Scheda id="documenti" n={3} titolo="Documenti da firmare" accent={A}>
        <P>Per "documento" si intende il <b>PDF da far firmare</b> (non il documento d'identità).</P>
        <Bullets items={[
          "Carica il PDF originale: viene conservato immutabile con impronta SHA-256.",
          "Puoi caricare nuove versioni; ogni versione è tracciata e scaricabile.",
          "Sono ammessi solo PDF (max 25MB).",
        ]} />
      </Scheda>

      <Scheda id="pratiche" n={4} titolo="Pratiche di firma" accent={A}>
        <P>La pratica lega un cliente a una versione del documento. Stati: <b>Bozza → In attesa → Firmata</b>; può essere Annullata; diventa Scaduta oltre il termine (7 giorni).</P>
        <Steps items={[
          "Crea la pratica scegliendo cliente e documento.",
          "Attiva il link (passa in 'In attesa') per abilitare la firma.",
          "Puoi copiare l'URL, annullare o eliminare la pratica.",
        ]} />
      </Scheda>

      <Scheda id="livelli" n={5} titolo="Livelli: OTP e OTP + documento" accent={A}>
        <P>Per ogni pratica scegli il livello di verifica:</P>
        <Bullets items={[
          "OTP via SMS: il cliente inserisce un codice ricevuto sul cellulare.",
          "OTP + documento d'identità: oltre all'OTP, il cliente carica un documento d'identità (conservato con impronta SHA-256).",
        ]} />
        <Callout tipo="info">La scelta si fa al momento della creazione della pratica, in base al documento e al contesto.</Callout>
      </Scheda>

      <Scheda id="invio" n={6} titolo="Invio link e promemoria" accent={A}>
        <Bullets items={[
          "All'attivazione puoi inviare il link al cliente via SMS e/o email.",
          "Promemoria automatici: se il cliente non firma entro X giorni, il sistema invia solleciti (numero massimo configurabile).",
        ]} />
      </Scheda>

      <Scheda id="cliente" n={7} titolo="Come firma il cliente" accent={A}>
        <Steps items={[
          "Il cliente apre il link (nessun accesso alla Suite richiesto).",
          "Visualizza il documento, inserisce l'OTP ricevuto (ed eventualmente carica il documento d'identità).",
          "Conferma la firma: vengono registrate le evidenze (data/ora, IP, dispositivo, impronta del documento).",
        ]} />
      </Scheda>

      <Scheda id="certificato" n={8} titolo="Certificato e documento firmato" accent={A}>
        <P>Al termine il sistema genera il <b>documento firmato</b>: timbro su ogni pagina + una pagina finale di <b>Certificato di firma elettronica</b> (firmatario, data/ora, metodo OTP/OTP+ID, telefono mascherato, SHA-256, ID pratica, IP).</P>
        <Bullets items={[
          "Il PDF firmato viene inviato via email al cliente e all'agenzia (info@assietica.it).",
          "Cliente e staff possono scaricare il documento firmato.",
        ]} />
      </Scheda>

      <Scheda id="legale" n={9} titolo="Valore e note legali" accent={A}>
        <Callout tipo="warn">Assietica Sign raccoglie una firma con OTP ed evidenze tecniche. Allo stato attuale <b>non</b> è una firma elettronica qualificata/avanzata (FEA/FEQ) né conservazione a norma: per questi livelli servono un provider certificato e una validazione legale dedicati.</Callout>
      </Scheda>

      <Scheda id="faq" n={10} titolo="Domande frequenti" accent={A}>
        <FAQ items={[
          { q: "Il cliente deve registrarsi?", a: "No: firma tramite il link ricevuto, senza account." },
          { q: "Posso obbligare il documento d'identità?", a: "Sì, scegliendo il livello 'OTP + documento d'identità' sulla pratica." },
          { q: "Dove trovo le evidenze della firma?", a: "Nel dettaglio della pratica (timeline eventi) e nella pagina di certificato del PDF firmato." },
          { q: "Come salvo questo manuale in PDF?", a: "Usa 'Stampa / Salva PDF' in alto a destra." },
        ]} />
      </Scheda>
    </ManualeLayout>
  );
}
